import { createContainer } from 'unstated-next'
import useSWR from 'swr'
import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { flatten, omit } from 'ramda'
import { submitAssignmentReview } from '../../../../../../../../API/Course'
import { notify } from '../../../../../../../../Helpers/Notifications'

const SubmissionsStore = createContainer(() => {
  const { submissionId } = useParams()

  const [courseId, setCourseId] = useState()
  const [chapters, setChapters] = useState([])

  const { data, error, mutate } = useSWR(
    courseId ? `/course/${courseId}/submissions` : null,
  )

  const submissions = useMemo(
    () =>
      data &&
      Object.fromEntries(
        flatten(
          Object.entries(data).map(([chapterId, assignments]) =>
            Object.entries(assignments).map(([assignmentId, submissions]) =>
              Object.entries(submissions).map(([submissionId, submission]) => ({
                chapterId,
                assignmentId,
                submissionId,
                ...submission,
              })),
            ),
          ),
        ).map((submission) => [submission.submissionId, submission]),
      ),
    [data],
  )

  const activeSubmission = useMemo(() => {
    if (!submissionId || !submissions) return null
    const submission = submissions[submissionId]
    const chapter = chapters.find(({ id }) => id === submission.chapterId)
    const lesson = chapter.lessons.find(
      ({ id }) => id === submission.assignmentId,
    )

    return { ...submission, chapter: omit(['lessons'], chapter), lesson }
  }, [chapters, submissionId, submissions])

  const submitReview = useCallback(
    async (review) => {
      const response = await submitAssignmentReview({
        courseId,
        chapterId: activeSubmission?.chapter.id,
        lessonId: activeSubmission?.lesson.id,
        submissionId: activeSubmission?.submissionId,
        reviewMessage: review,
      })

      if (response) {
        await mutate()
        notify('success', `Submitted your review successfully!`)
      }
    },
    [activeSubmission, courseId, mutate],
  )

  return {
    loading: !data,
    loadFailed: Boolean(error),
    data,
    chapters,
    submissions,
    config: courseId,
    activeSubmission,
    setCourseId,
    setChapters,
    submitReview,
  }
})

export default SubmissionsStore
